// GetQuizFile (an action file)

const findMistake = (quizOptions, quizRows, state) => {
  console.log("state.websiteLang", state.websiteLang )

  if (quizOptions.length < 2 || quizRows.length < 5) {

    const mistake = state.websiteLang === "en"
      ? "The quiz must have at least 2 columns and 5 rows."
      : "В квизе должно быть хотя бы 2 столбца и хотя бы 5 строк.";

    return mistake;

  } else {

    //check if all rows have the same length
    const checkRowsLength = () => {
      const getKeys = quizRows.map((key) =>
        Object.keys(key).length
      );
      return getKeys.filter((el, i) =>
        getKeys.indexOf(el) === i);
    };

    if (checkRowsLength().length > 1) {

      const mistake = state.websiteLang === "en"
        ? "The columns must be of the same length."
        : "Столбцы должны содержать одинаковое количество строк.";

      return mistake;

    } else if (quizOptions.length !== checkRowsLength()[0]) {

      //check if options have the required length

      const mistake = state.websiteLang === "en"
        ? "Each column must have a unique header."
        : "Название каждого столбца должно быть уникальным.";

      return mistake;

    } else {

      // check if there are empty or duplicate values in options
      const checkForEmpty = quizOptions.filter(el => el.toString().trim() === "");
      const lowCaseOptions = quizOptions.map((val) => val.toString().toLowerCase());
      const checkForDuplicates = lowCaseOptions.filter((el, i) => lowCaseOptions.indexOf(el) === i);

      if (checkForEmpty.length || checkForDuplicates.length < quizOptions.length) {

        const mistake = state.websiteLang === "en"
          ? "Each column header must have a unique value and can’t be empty."
          : "У каждого столбца должно быть название, и оно должно быть уникальным.";

        return mistake;

      } else {

        // check if there are empty or duplicate values in rows
        const rowsForCheck = quizOptions.map((h, hi) => {
          return { [h]: quizRows.map((val, i) => val[h]) }
        });
        const checkRowsContents = rowsForCheck.map((val) => {
          const checkForEmpty = Object.values(val)[0].filter(el => el.toString().trim() === "");
          const lowCaseRows = Object.values(val)[0].map((val) => val.toString().toLowerCase());
          const checkForDuplicates = lowCaseRows.filter((el, i) => lowCaseRows.indexOf(el) === i);
          if (checkForEmpty.length || checkForDuplicates.length < Object.values(val)[0].length) {
            return true
          } else {
            return false
          };
        });
        if (checkRowsContents.filter(el => el === true).length) {

          const mistake = state.websiteLang === "en"
            ? "Each cell of a column must have a unique value and can’t be empty."
            : "Все ячейки столбца должны быть заполнены и иметь уникальное значение.";

          return mistake;

        } else {
          return null
        };
      };
    };
  };
};

export default findMistake